export const companyProfile = {
  name: "Hailo Digital",
  legalName: "Hailo Technologies LLC",
  tagline: "Intelligent Digital Systems",
  supportingLine:
    "Custom software and AI development services for modern digital products.",
  contactEmail: "admin@hailodigital.com",
  registeredLocation: "Registered in New Jersey, United States",
  footerCopy: "© 2026 Hailo Technologies LLC. All rights reserved.",
};

export const navigationItems = [
  { label: "Home", href: "/" },
  { label: "Company", href: "/company" },
  { label: "Work", href: "/work" },
  { label: "Contact", href: "/contact" },
];

export const companyParagraphs = [
  "Hailo Digital is the public operating brand and sole division of Hailo Technologies LLC, a New Jersey-registered technology company building intelligent digital products and modern software systems.",
  "We engage with clients on custom software development and AI development services, delivered under written engagement agreements scoped to each project.",
  "Our work spans bespoke software, AI systems, digital platforms, and emerging technology initiatives for businesses building serious digital products.",
];

export const companyFocusAreas = [
  "Custom Software Development",
  "AI Development Services",
  "Digital Platforms",
  "Emerging Technology",
];

export const services = [
  {
    name: "Custom Software Development",
    description:
      "End-to-end design and engineering of bespoke software, web platforms, and internal tools tailored to client requirements.",
  },
  {
    name: "AI Development Services",
    description:
      "Development of artificial intelligence systems, integrations, and applied machine learning workflows for digital products.",
  },
];

export const servicesPricingNote =
  "Engagements are scoped per project. Contact admin@hailodigital.com for pricing or a custom quote.";

export const products = [
  {
    name: "Hailo",
    description:
      "Hailo is a platform developed by Hailo Digital focused on helping individuals better understand and monitor their digital identity.",
    url: "https://gethailo.ai",
    ctaLabel: "Explore Hailo",
  },
  {
    name: "MyFaceSearch",
    description:
      "MyFaceSearch is a facial similarity search service that scans publicly indexed web content to identify visually matching faces, enabling users to locate online appearances while maintaining strict data privacy and security standards.",
    url: "https://myfacesearch.com",
    ctaLabel: "Explore MyFaceSearch",
  },
];
